import React from 'react';
import styles from './heroBannerCenterAligned.module.css';
import Markdown from 'markdown-to-jsx';
import {Button} from '../VideoPlayer/VideoPlayer';
import StaticImage from '../Images/ImageComponent/Image';

function HeroBannerCenterAligned({data}: any) {
    if (!data) return null;

    return (
        <div className={styles.root}>
            {data?.backgroundImage && (
                <StaticImage
                    image={data?.backgroundImage}
                    alt="Center Aligned Hero Banner Image"
                    data-target="center-aligned-hero-banner-image"
                />
            )}
            <div className={styles.container}>
                {data?.title && (
                    <Markdown className={styles.title}>{data?.title}</Markdown>
                )}
                {data?.description && (
                    <Markdown className={styles.description}>
                        {data?.description}
                    </Markdown>
                )}

                {data?.buttons && (
                    <div className={styles.buttonContainer}>
                        {data?.buttons?.map((button: any) => (
                            <div className={styles.boxButtons}>
                                {button?.buttonboxtitle && (
                                    <div>{button.buttonboxtitle}</div>
                                )}
                                {button?.buttonData && (
                                    <Button
                                        label={button?.buttonData?.label}
                                        className={styles.buttonStyle}
                                        onClick={() =>
                                            button?.buttonData?.action()
                                        }
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default HeroBannerCenterAligned;
